// extracted by mini-css-extract-plugin
export default {"article_map__wrapper":"ArticleMap_article_map__wrapper__xo-eB"};